import __request__ from "routing/request";
export function getFavoriteItems(page = 1, per_page = 5, type, requestOptions) {
  return __request__("GET", "/favorites", null, { "page": page, "per_page": per_page, "type": type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addItemToFavorites(grn, requestOptions) {
  return __request__("PUT", `/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeItemFromFavorites(grn, requestOptions) {
  return __request__("DELETE", `/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
